
import React, { createContext, useContext } from 'react'
import { useProjects } from '@/hooks/useProjects'

type ProjectsContextType = ReturnType<typeof useProjects>

const ProjectsContext = createContext<ProjectsContextType | null>(null)

export function ProjectsProvider({ children }: { children: React.ReactNode }) {
  const projects = useProjects()
  return (
    <ProjectsContext.Provider value={projects}>
      {children}
    </ProjectsContext.Provider>
  )
}

export function useSharedProjects(): ProjectsContextType {
  const context = useContext(ProjectsContext)
  if (!context) {
    throw new Error('useSharedProjects must be used within ProjectsProvider')
  }
  return context
}
